import * as React from 'react';
import {YearMonth} from "./utils/YearMonthRangePicker";
import furoApi from "../api/FuroApi";
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from "../app/ApplicationContext";
import {ErrorResponse} from "../api/dtos/dtos";
import {ErrorAlert} from "../common/ErrorAlert";
import './utils/Statistics.css';
import {StatisticsRequest, TypeValue} from "../api/dtos/statistics";
import IncomingInvoiceTypeDistributionStatisticsPanel from './IncomingInvoiceTypeDistributionStatisticsPanel';


interface State {
  typeCostStatistics?: TypeValue[];
  error?: ErrorResponse;
}

class IncomingInvoiceStatisticsPage extends React.Component<{}, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {};

  public render(): React.ReactNode {
    const {typeCostStatistics, error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <IncomingInvoiceTypeDistributionStatisticsPanel
          onQueryParamsChange={this.onQueryParamsChange}
          typeCostStatistics={typeCostStatistics}
        />

        <ErrorAlert style={{marginTop: 16}} error={error}/>
      </>
    );
  }

  private onQueryParamsChange = (start: YearMonth, end: YearMonth) => {
    const request: StatisticsRequest = {
      startYear: start.year,
      startMonth: start.month,
      endYear: end.year,
      endMonth: end.month
    };
    this.loadStatisticsInRange(request);
  };

  private loadStatisticsInRange = (request: StatisticsRequest) => {
    const promise = furoApi.statistics.getIncomingInvoiceStatistics(request)
      .then(response => this.setState({
        typeCostStatistics: response.typeCostStatistics,
        error: undefined,
      }))
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default IncomingInvoiceStatisticsPage;


// WEBPACK FOOTER //
// ./src/statistics/IncomingInvoiceStatisticsPage.tsx